import * as React from "react";
const SvgForward = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M21.66,11,14.84,4.68a1,1,0,1,0-1.41,1.53l4.9,4.52H3a1,1,0,0,0,0,2.08H18.4l-5,5a1,1,0,0,0,.73,1.77,1,1,0,0,0,.74-.3l6.82-6.82a1,1,0,0,0,.31-.76A1.05,1.05,0,0,0,21.66,11Z" }));
export default SvgForward;
